export interface Comic {
  id: string;
  title: string;
  author: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  chapterCount: number;
  latest: string;
  updatedAt: string;
  tags: string[];
  description: string;
  cover: string;
  banner: string;
  hot: boolean;
  recommend: boolean;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
  count: number;
}

export const categories: Category[] = [
  { id: 'fantasy', name: '奇幻冒险', icon: 'ri-sparkling-2-line', desc: '魔法、异世界与冒险故事', count: 328 },
  { id: 'urban', name: '都市异能', icon: 'ri-building-2-line', desc: '都市背景的超能力与日常', count: 251 },
  { id: 'sci-fi', name: '科幻机甲', icon: 'ri-robot-2-line', desc: '未来世界、机械与星际战争', count: 197 },
  { id: 'wuxia', name: '武侠仙侠', icon: 'ri-sword-line', desc: '江湖恩怨与修仙问道', count: 214 },
  { id: 'mystery', name: '悬疑推理', icon: 'ri-eye-2-line', desc: '烧脑案件与惊悚反转', count: 143 },
  { id: 'romance', name: '恋爱校园', icon: 'ri-heart-3-line', desc: '心动日常与青春故事', count: 236 },
  { id: 'healing', name: '治愈日常', icon: 'ri-sun-line', desc: '温暖轻快的治愈小品', count: 165 },
  { id: 'sports', name: '热血运动', icon: 'ri-trophy-line', desc: '球类、竞技与汗水青春', count: 88 },
  { id: 'food', name: '美食剧场', icon: 'ri-restaurant-line', desc: '舌尖上的美食人生', count: 74 },
  { id: 'horror', name: '惊悚灵异', icon: 'ri-ghost-2-line', desc: '深夜恐惧与灵异传说', count: 96 },
];

export const comics: Comic[] = [
  {
    id: 'xingchen',
    title: '星辰坠落之地',
    author: '林雾',
    status: '连载中',
    rating: 9.4,
    views: '1284.6万',
    chapterCount: 186,
    latest: '第186话 星火燎原',
    updatedAt: '08-18',
    tags: ['奇幻冒险', '魔法', '热血'],
    description:
      '一颗坠落人间的星辰，改变了一个平凡少年的命运。少年阿澈在星痕中觉醒掌握星光之力的天赋，卷入古神陨落千年的秘密。伙伴、宿敌、被封印的真相，随着流星雨再度降临而揭开。每一话都保持原版分镜与完整剧情，热血与温情并存。',
    cover: 'https://readdy.ai/api/search-image?query=A%20young%20boy%20holding%20a%20glowing%20star%20pendant%20standing%20in%20a%20dark%20fantasy%20world%20under%20falling%20meteors%20with%20sparkling%20star%20trails%2C%20dramatic%20cinematic%20lighting%2C%20vibrant%20warm%20orange%20and%20gold%20color%20palette%2C%20detailed%20anime%20style%20comic%20book%20cover%20illustration%2C%20dynamic%20composition%2C%20rich%20atmosphere%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-xingchen&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=epic%20fantasy%20scene%20of%20meteor%20shower%20over%20a%20dark%20mountain%20city%20with%20a%20hero%20silhouette%20reaching%20for%20the%20sky%2C%20gold%20and%20orange%20starlight%20beams%2C%20dramatic%20cinematic%20composition%2C%20anime%20style%20wide%20illustration%2C%20high%20detail%2C%20moody%20atmosphere&width=1600&height=900&seq=banner-xingchen&orientation=landscape',
    hot: true,
    recommend: true,
  },
  {
    id: 'dushi',
    title: '都市异能觉醒',
    author: '半盏灯',
    status: '连载中',
    rating: 8.8,
    views: '965.2万',
    chapterCount: 143,
    latest: '第143话 暗夜行动',
    updatedAt: '08-18',
    tags: ['都市', '异能', '热血'],
    description:
      '普通上班族顾言在深夜加班时觉醒异能，从此踏入城市地下的异能者世界。没有惊天开局，只有一步步成长。原版剧情完整呈现，打斗分镜酣畅淋漓，人物成长线扎实，是近年难得一见的硬核都市异能长篇。',
    cover: 'https://readdy.ai/api/search-image?query=young%20man%20in%20modern%20city%20at%20night%20with%20glowing%20energy%20power%20around%20his%20hand%2C%20neon%20city%20lights%20and%20dark%20sky%2C%20dramatic%20orange%20and%20amber%20lighting%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20dynamic%20pose%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-dushi&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=dark%20metropolis%20skyline%20at%20night%20with%20a%20lone%20figure%20casting%20glowing%20energy%20across%20rooftops%2C%20neon%20and%20amber%20city%20lights%2C%20dramatic%20anime%20style%20wide%20scene%2C%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=banner-dushi&orientation=landscape',
    hot: true,
    recommend: false,
  },
  {
    id: 'jiandao',
    title: '剑道独尊',
    author: '雁归楼',
    status: '已完结',
    rating: 9.1,
    views: '1570.8万',
    chapterCount: 412,
    latest: '大结局 剑破长空',
    updatedAt: '08-16',
    tags: ['武侠', '仙侠', '励志'],
    description:
      '少年剑痴背负断剑，从边陲小城一路问剑天下。斩妖邪、会群雄、登天阙，一剑霜寒十四州。全书四百余话一气呵成，结局圆满不烂尾，导演剪辑版补全了删减的巅峰对决，武侠迷不容错过的经典长篇。',
    cover: 'https://readdy.ai/api/search-image?query=a%20sword%20master%20in%20flowing%20robes%20holding%20a%20gleaming%20sword%20on%20a%20misty%20mountain%20peak%2C%20traditional%20wuxia%20fantasy%20atmosphere%2C%20warm%20gold%20and%20orange%20lighting%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20dynamic%20and%20heroic%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-jiandao&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=wuxia%20swordsman%20standing%20on%20a%20cliff%20overlooking%20cloudy%20mountains%20with%20sunlight%20breaking%20through%2C%20epic%20scale%2C%20warm%20golden%20tones%2C%20anime%20style%20wide%20illustration%2C%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=banner-jiandao&orientation=landscape',
    hot: true,
    recommend: true,
  },
  {
    id: 'jijia',
    title: '机甲纪元',
    author: '铁罐头',
    status: '连载中',
    rating: 9.0,
    views: '832.4万',
    chapterCount: 158,
    latest: '第158话 母星反攻',
    updatedAt: '08-17',
    tags: ['科幻', '机甲', '战争'],
    description:
      '人类文明在星际战争中被逼至绝境，少年机师驾驶旧式机甲踏上反攻之路。宏大世界观、考究的机体设计、完整的剧情脉络，原版画面细节与删减的战斗场景全数保留，科幻机甲迷的视觉盛宴。',
    cover: 'https://readdy.ai/api/search-image?query=a%20young%20pilot%20in%20a%20cockpit%20with%20a%20towering%20mech%20robot%20behind%20him%2C%20space%20battlefield%20with%20explosions%20and%20stars%2C%20dramatic%20warm%20orange%20and%20gold%20lighting%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20epic%20dynamic%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-jijia&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=giant%20mech%20army%20facing%20a%20vast%20space%20battle%20with%20planet%20in%20background%2C%20lens%20flares%20and%20explosions%2C%20warm%20orange%20and%20gold%20tones%2C%20anime%20style%20wide%20scene%2C%20epic%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=banner-jijia&orientation=landscape',
    hot: true,
    recommend: false,
  },
  {
    id: 'qiuhun',
    title: '热血球魂',
    author: '一撇',
    status: '连载中',
    rating: 8.7,
    views: '645.1万',
    chapterCount: 121,
    latest: '第121话 决胜一球',
    updatedAt: '08-18',
    tags: ['运动', '篮球', '青春'],
    description:
      '身材矮小的控卫秦朗逆流而上，带领一帮"问题少年"打进全国大赛。比赛场面张力十足，人物成长真挚动人，完整的战术布局与热血结局让人热血沸腾。运动漫画里少见的高完成度长篇。',
    cover: 'https://readdy.ai/api/search-image?query=a%20young%20basketball%20player%20dribbling%20on%20a%20night%20court%20with%20dramatic%20spotlight%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20amber%20lighting%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20energetic%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-qiuhun&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=intense%20basketball%20game%20moment%20with%20player%20jumping%20for%20a%20shot%20under%20bright%20arena%20lights%2C%20crowd%20silhouettes%2C%20warm%20orange%20tone%2C%20anime%20style%20wide%20scene%2C%20dynamic%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=banner-qiuhun&orientation=landscape',
    hot: false,
    recommend: false,
  },
  {
    id: 'mengchong',
    title: '萌宠咖啡屋',
    author: '软糖',
    status: '连载中',
    rating: 9.3,
    views: '1102.9万',
    chapterCount: 96,
    latest: '第96话 雨天的小秘密',
    updatedAt: '08-18',
    tags: ['治愈', '日常', '萌宠'],
    description:
      '在街角一家小小的宠物咖啡屋里，人与毛茸茸的小动物们相互治愈。画风温暖治愈，日常故事细腻动人，没有任何压抑与删减，只有满满的温柔与笑声。压力大的时候翻开它，心情都会变好。',
    cover: 'https://readdy.ai/api/search-image?query=adorable%20cats%20and%20dogs%20gathered%20around%20a%20cozy%20coffee%20shop%20table%20with%20a%20kind%20barista%2C%20warm%20soft%20lighting%20and%20pastel%20orange%20tone%2C%20cute%20anime%20style%20comic%20book%20cover%20illustration%2C%20gentle%20heartwarming%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-mengchong&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=cozy%20little%20pet%20cafe%20interior%20with%20sunlight%20streaming%20in%20and%20soft%20animals%20relaxing%2C%20warm%20golden%20hour%20tone%2C%20cute%20anime%20style%20wide%20scene%2C%20gentle%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=banner-mengchong&orientation=landscape',
    hot: false,
    recommend: true,
  },
  {
    id: 'xuanan',
    title: '悬案密码',
    author: '灰雀',
    status: '已完结',
    rating: 9.2,
    views: '718.5万',
    chapterCount: 78,
    latest: '大结局 真相大白',
    updatedAt: '08-14',
    tags: ['悬疑', '推理', '犯罪'],
    description:
      '天才刑警与神秘搭档联手侦破一系列无解悬案。每起案件层层反转，线索埋设滴水不漏，原版推理逻辑完整呈现，未被任何删减破坏节奏。结局惊艳，推理爱好者的心头好。',
    cover: 'https://readdy.ai/api/search-image?query=a%20mysterious%20detective%20in%20a%20trench%20coat%20holding%20a%20magnifying%20glass%20under%20dim%20street%20light%20with%20shadows%20and%20yellow%20light%2C%20suspenseful%20mood%2C%20warm%20amber%20and%20orange%20tones%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20mysterious%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-xuanan&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=noir%20detective%20scene%20in%20a%20rainy%20dark%20city%20alley%20with%20yellow%20lamplight%20and%20long%20shadows%2C%20mysterious%20mood%2C%20warm%20amber%20tones%2C%20anime%20style%20wide%20scene%2C%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=banner-xuanan&orientation=landscape',
    hot: false,
    recommend: true,
  },
  {
    id: 'haomen',
    title: '豪门千金不认命',
    author: '桑葚',
    status: '连载中',
    rating: 8.6,
    views: '542.7万',
    chapterCount: 132,
    latest: '第132话 重新出发',
    updatedAt: '08-17',
    tags: ['恋爱', '校园', '励志'],
    description:
      '被家族抛弃的千金小姐白芷褪去光环，在校园里从零开始打拼。她与竹马青梅、高冷学霸之间细腻的情感发展真实动人，原版剧情完整无删改，女主的成长看得人又酸又暖。',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20young%20woman%20in%20a%20sunlit%20university%20courtyard%20with%20warm%20glowing%20bokeh%2C%20confident%20expression%2C%20soft%20warm%20orange%20and%20gold%20tones%2C%20anime%20style%20romance%20comic%20book%20cover%20illustration%2C%20gentle%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-haomen&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=romantic%20campus%20scene%20at%20golden%20hour%20with%20a%20young%20woman%20walking%20under%20cherry%20blossom%20trees%2C%20warm%20sunlight%20and%20soft%20bokeh%2C%20anime%20style%20wide%20scene%2C%20gentle%20romantic%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=banner-haomen&orientation=landscape',
    hot: false,
    recommend: false,
  },
  {
    id: 'honghuang',
    title: '洪荒之主',
    author: '沧澜',
    status: '连载中',
    rating: 9.0,
    views: '1356.3万',
    chapterCount: 224,
    latest: '第224话 开天辟地',
    updatedAt: '08-18',
    tags: ['玄幻', '修仙', '热血'],
    description:
      '洪荒末年，天地大劫将至。少年盘古后裔背负守护苍生的使命，在混沌中开辟新纪元。宏大世界观与震撼的场面描写，导演剪辑版补全了被删减的史诗级大战，玄幻读者绝不能错过的年度之作。',
    cover: 'https://readdy.ai/api/search-image?query=a%20mighty%20cultivator%20surrounded%20by%20swirling%20cosmic%20energy%20and%20ancient%20ruins%2C%20epic%20primordial%20fantasy%20world%2C%20warm%20gold%20and%20orange%20glow%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20majestic%20dynamic%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-honghuang&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=ancient%20primordial%20battle%20in%20the%20sky%20over%20vast%20mountains%20with%20colossal%20creatures%20and%20energy%20beams%2C%20golden%20and%20orange%20light%2C%20epic%20anime%20style%20wide%20scene%2C%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=banner-honghuang&orientation=landscape',
    hot: true,
    recommend: true,
  },
  {
    id: 'meishi',
    title: '深夜美食猎人',
    author: '灶王爷',
    status: '已完结',
    rating: 8.9,
    views: '489.6万',
    chapterCount: 88,
    latest: '大结局 人间至味',
    updatedAt: '08-15',
    tags: ['美食', '治愈', '日常'],
    description:
      '退役厨师接手深夜食堂，用一道道上头的料理温暖每个深夜孤独的食客。每话一道菜、一个故事，原版食谱与完整剧情都在，看完忍不住想冲进厨房。温暖又下饭的美食漫画。',
    cover: 'https://readdy.ai/api/search-image?query=steaming%20bowl%20of%20noodles%20on%20a%20cozy%20night%20street%20food%20stall%20with%20warm%20lantern%20light%2C%20delicious%20appetizing%20food%2C%20warm%20orange%20and%20gold%20tones%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20cozy%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-meishi&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=charming%20night%20street%20food%20stall%20with%20steam%20rising%20from%20delicious%20dishes%20under%20warm%20lanterns%20on%20a%20rainy%20night%2C%20warm%20orange%20tones%2C%20anime%20style%20wide%20scene%2C%20cozy%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=banner-meishi&orientation=landscape',
    hot: false,
    recommend: false,
  },
  {
    id: 'xingji',
    title: '星际废土行',
    author: '灰烬',
    status: '连载中',
    rating: 8.8,
    views: '603.2万',
    chapterCount: 104,
    latest: '第104话 绿洲协议',
    updatedAt: '08-16',
    tags: ['科幻', '废土', '冒险'],
    description:
      '地球沦陷后，幸存者们在废土中寻找最后的绿洲。生存、背叛、希望交织，原版场景与情节完整保留，废土美学独树一帜，结局伏笔埋得又深又妙。硬核科幻迷的年度惊喜。',
    cover: 'https://readdy.ai/api/search-image?query=a%20lone%20survivor%20in%20tattered%20gear%20walking%20through%20a%20post-apocalyptic%20wasteland%20with%20rusty%20ruins%20under%20a%20huge%20sun%2C%20warm%20orange%20and%20amber%20lighting%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20epic%20solitary%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-xingji&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=vast%20post-apocalyptic%20wasteland%20with%20a%20lone%20figure%20and%20distant%20ruined%20city%20under%20a%20massive%20orange%20sunset%2C%20harsh%20beautiful%20light%2C%20anime%20style%20wide%20scene%2C%20epic%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=banner-xingji&orientation=landscape',
    hot: true,
    recommend: false,
  },
  {
    id: 'xiaying',
    title: '侠影江湖',
    author: '孤舟',
    status: '已完结',
    rating: 9.1,
    views: '1147.8万',
    chapterCount: 268,
    latest: '大结局 快意恩仇',
    updatedAt: '08-13',
    tags: ['武侠', '江湖', '群像'],
    description:
      '一纸武林令，搅动整个江湖。刀客、剑客、镖师、女侠，群像刻画入木三分。原版江湖恩怨与删减的经典对决完整呈现，侠者快意恩仇与家国情怀交织，武侠漫的集大成之作。',
    cover: 'https://readdy.ai/api/search-image?query=shadowy%20martial%20artist%20in%20a%20rooftop%20duel%20under%20moonlight%20in%20an%20ancient%20chinese%20town%2C%20warm%20gold%20lantern%20light%20and%20moonlight%2C%20wuxia%20atmosphere%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20dramatic%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-xiaying&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=martial%20artists%20dueling%20on%20rooftops%20of%20an%20ancient%20chinese%20city%20at%20night%20with%20lanterns%20and%20moon%2C%20dynamic%20action%2C%20warm%20gold%20tones%2C%20anime%20style%20wide%20scene%2C%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=banner-xiaying&orientation=landscape',
    hot: false,
    recommend: true,
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '麻瓜漫画网的漫画都是原版无删减的吗？',
    a: '是的。麻瓜漫画网致力于收录原版漫画资源，页面中的漫画均保留完整的原版分镜、对白与剧情，未经删减处理，力求让你看到最原汁原味的漫画内容。',
  },
  {
    q: '什么是"导演剪辑版"漫画？',
    a: '导演剪辑版指在原版基础上补全了部分被删减或调整的剧情、番外与幕后设定内容的完整版本。麻瓜漫画网的导演剪辑版漫画会完整呈现这些追加内容。',
  },
  {
    q: '在麻瓜漫画网追更需要付费吗？',
    a: '麻瓜漫画网的大部分漫画都可以直接在线免费阅读，不需要额外付费即可追更最新章节。部分内容我们也会以合理的会员形式支持创作，但不会影响基础阅读体验。',
  },
  {
    q: '漫画更新频率如何？',
    a: '连载中的漫画我们会尽量同步更新，大部分作品每日或每周固定更新。你可以在漫画详情页关注收藏，更新后第一时间收到提醒。',
  },
  {
    q: '移动端阅读体验如何？',
    a: '麻瓜漫画网采用响应式设计，手机、平板、电脑均可流畅阅读。漫画按分页清晰排版，支持横竖屏切换，阅读进度会自动保存。',
  },
  {
    q: '可以离线缓存漫画吗？',
    a: '目前支持将已读章节缓存到本地，方便你在无网络环境下继续阅读。请在阅读页开启离线缓存功能即可。',
  },
];

export interface RankItem {
  id: string;
  title: string;
  cover: string;
  rating: number;
  views: string;
  change: string;
}

export const rankByViews: RankItem[] = [
  { id: 'jiandao', title: '剑道独尊', cover: 'https://readdy.ai/api/search-image?query=a%20sword%20master%20in%20flowing%20robes%20holding%20a%20gleaming%20sword%20on%20a%20misty%20mountain%20peak%2C%20traditional%20wuxia%20fantasy%20atmosphere%2C%20warm%20gold%20and%20orange%20lighting%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20dynamic%20and%20heroic%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-jiandao&orientation=portrait', rating: 9.1, views: '1570.8万', change: '持平' },
  { id: 'honghuang', title: '洪荒之主', cover: 'https://readdy.ai/api/search-image?query=a%20mighty%20cultivator%20surrounded%20by%20swirling%20cosmic%20energy%20and%20ancient%20ruins%2C%20epic%20primordial%20fantasy%20world%2C%20warm%20gold%20and%20orange%20glow%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20majestic%20dynamic%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-honghuang&orientation=portrait', rating: 9.0, views: '1356.3万', change: '持平' },
  { id: 'xingchen', title: '星辰坠落之地', cover: 'https://readdy.ai/api/search-image?query=A%20young%20boy%20holding%20a%20glowing%20star%20pendant%20standing%20in%20a%20dark%20fantasy%20world%20under%20falling%20meteors%20with%20sparkling%20star%20trails%2C%20dramatic%20cinematic%20lighting%2C%20vibrant%20warm%20orange%20and%20gold%20color%20palette%2C%20detailed%20anime%20style%20comic%20book%20cover%20illustration%2C%20dynamic%20composition%2C%20rich%20atmosphere%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-xingchen&orientation=portrait', rating: 9.4, views: '1284.6万', change: '↑2' },
  { id: 'xiaying', title: '侠影江湖', cover: 'https://readdy.ai/api/search-image?query=shadowy%20martial%20artist%20in%20a%20rooftop%20duel%20under%20moonlight%20in%20an%20ancient%20chinese%20town%2C%20warm%20gold%20lantern%20light%20and%20moonlight%2C%20wuxia%20atmosphere%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20dramatic%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-xiaying&orientation=portrait', rating: 9.1, views: '1147.8万', change: '↑1' },
  { id: 'mengchong', title: '萌宠咖啡屋', cover: 'https://readdy.ai/api/search-image?query=adorable%20cats%20and%20dogs%20gathered%20around%20a%20cozy%20coffee%20shop%20table%20with%20a%20kind%20barista%2C%20warm%20soft%20lighting%20and%20pastel%20orange%20tone%2C%20cute%20anime%20style%20comic%20book%20cover%20illustration%2C%20gentle%20heartwarming%20composition%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-mengchong&orientation=portrait', rating: 9.3, views: '1102.9万', change: '↑3' },
  { id: 'dushi', title: '都市异能觉醒', cover: 'https://readdy.ai/api/search-image?query=young%20man%20in%20modern%20city%20at%20night%20with%20glowing%20energy%20power%20around%20his%20hand%2C%20neon%20city%20lights%20and%20dark%20sky%2C%20dramatic%20orange%20and%20amber%20lighting%2C%20anime%20style%20comic%20book%20cover%20illustration%2C%20dynamic%20pose%2C%20high%20quality%20digital%20painting%20with%20clean%20linework&width=480&height=720&seq=cover-dushi&orientation=portrait', rating: 8.8, views: '965.2万', change: '持平' },
];